const translations = {
  "en": {
    "%{var0} by": "%{var0} by"
  },
  "zh-tw": {
    "%{var0} by": "%{var0} 作者"
  }
};

export default translations;
